import { CommonModule, DOCUMENT } from '@angular/common'
import { AfterViewInit, ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core'
import { NgElement, WithProperties } from '@angular/elements'
import { registerCustomElementFactory } from '../../custom-elements/register-custom-element-factory'

/**
 * @public
 *
 * @deprecated
 */
export type RedirectElement = NgElement & WithProperties<RedirectComponent>

/**
 * @public
 *
 * @todo {@link https://jira.gpei.ca/browse/API-4057 API-4057}
 *
 * @deprecated
 *  This component is deprecated in favor of a redirect being handled through the behaviour of the application
 *  that uses this component.
 */
@Component({
  selector: 'gpei-redirect',
  templateUrl: './redirect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CommonModule ]
})
export class RedirectComponent implements AfterViewInit {

  private readonly _document = inject(DOCUMENT)

  @Input()
  @HostBinding()
  redirect: string

  ngAfterViewInit() {
    this._document.location.replace(this.redirect)
  }
}

/**
 * @public
 *
 * @deprecated
 */
export const registerRedirectElement = registerCustomElementFactory(RedirectComponent)
